import React from 'react';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './config/ReactotronConfig';

import { LaLigaBoundary, LaLigaProvider } from '@laliga-cdac/react';
import { theme } from '~/styles/theme';
import Routes from './routes';
import history from './config/history';

import { store, persistor } from './store';

import GlobalStyle from './styles/global';
import Tracking from './config/tracking';
import Fallback from './components/FallBack';
import { sendMonolog } from './services/api';

require('dotenv').config();

function App() {
  return (
    <LaLigaProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <PersistGate loading={null} persistor={persistor}>
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_GOOGLE_API_KEY}
            >
              <Router history={history}>
                <LaLigaBoundary
                  instance={Tracking}
                  fallback={<Fallback />}
                  onError={(error, info, location) =>
                    sendMonolog(error, info, location)
                  }
                >
                  <Routes />
                </LaLigaBoundary>
              </Router>
            </GoogleReCaptchaProvider>
            <GlobalStyle />
            <ToastContainer autoClose={3000} />
          </PersistGate>
        </ThemeProvider>
      </Provider>
    </LaLigaProvider>
  );
}

export default App;
